import React, { useState, useRef, useEffect } from 'react';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import useDebounce from '../../../core/common/hooks/useDebounce';
import { useEditUserApiMutation } from '../../../core/Features/api';
import { useDispatch } from 'react-redux';


interface BannerProps {
    setAkash: React.Dispatch<React.SetStateAction<any>>;
    destinations: any,
    setSelectedId: React.Dispatch<React.SetStateAction<any>>;
}



const SearchFilterSort: React.FC<BannerProps> = ({ setAkash, destinations,setSelectedId }) => {
    const dispatch = useDispatch()
    const countries = destinations || []
    //  [
    //     { name: 'USA', img: '/assets/flags/usa.png' },
    //     { name: 'Germany', img: '/assets/flags/germany.png' },
    //     { name: 'Australia', img: '/assets/flags/australia.png' },
    //     { name: 'Canada', img: '/assets/flags/canada.png' },
    //     { name: 'UK', img: '/assets/flags/uk.png' },
    // ];

    const options = ['India', 'America', 'China', 'France'];
    const [searchText, setSearchText] = useState<string>('');
    const debouncedSearchText = useDebounce(searchText, 500); // 500ms delay

    const [selected, setSelected] = useState<string>('Study destination');
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value.toLowerCase());
    };
    useEffect(() => {

        setAkash(debouncedSearchText)
    }, [debouncedSearchText])
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="w-full px-4 py-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 flex-wrap">

                {/* Search Input Group */}
                <div className="flex w-full md:w-[45%] h-[52px] border border-gray-300 rounded-md overflow-hidden shadow-sm">
                    <input
                        value={searchText}
                        onChange={handleSearch}

                        type="text"
                        placeholder="Search for university by keywords"
                        className="flex-grow px-4 text-sm focus:outline-none"
                    />
                    {/* <button className="bg-[#EA1D2A] text-white w-10 h-10 rounded-md flex items-center justify-center m-2">
                        <span className="text-xl font-bold">→</span>
                    </button> */}
                </div>

                {/* Dropdown */}
                <div className="w-full md:w-[35%] relative" ref={dropdownRef}>
                    <div
                        className="flex items-center h-[52px] justify-between px-3 py-1 p-1 border rounded-md shadow-sm bg-white cursor-pointer"
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        <div className="community-count p-2 mt-2">
                            <div className="enrolled-list">
                                <div className="avatar-list-stacked mb-2">
                                    {
                                        countries?.map((item: any, index: number) => <span className="avatar avatar-rounded">
                                            <ImageWithBasePath
                                                className="border border-white"
                                                source={item?.countryImage}
                                                alt="img"
                                            />
                                        </span>)
                                    }

                                    {/* countryImage */}

                                    {/* <span className="avatar avatar-rounded">
                                        <ImageWithBasePath
                                            className="border border-white"
                                            src="assets/img/user/user-03.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    <span className="avatar avatar-rounded">
                                        <ImageWithBasePath
                                            className="border border-white"
                                            src="assets/img/user/user-07.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    <span className="avatar avatar-rounded">
                                        <ImageWithBasePath
                                            className="border border-white"
                                            src="assets/img/user/user-08.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    <span className="avatar avatar-rounded">
                                        <ImageWithBasePath src="assets/img/user/user-06.jpg" alt="img" />
                                    </span> */}
                                </div>
                            </div>
                        </div>

                        {/* Selected Label */}
                        <span className="text-sm text-gray-700 ml-3 flex-1 truncate">{selected}</span>

                        {/* Dropdown Icon */}
                        <svg
                            className={`w-4 h-4 text-gray-500 transform transition-transform duration-200 ${showDropdown ? 'rotate-180' : ''
                                }`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>

                    {/* Dropdown Options */}
                    {showDropdown && (
                        <div className="absolute mt-1 w-full bg-white border rounded-md shadow z-50">
                            {countries?.map((option: any, index: number) => (
                                <div
                                    key={index}
                                    className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                        setSelected(option?.countryName);
                                        setSelectedId(option?._id);
                                        setShowDropdown(false);
                                    }}
                                >
                                      <div className='flex items-center gap-2'>

                                    <span className="avatar avatar-rounded">
                                        <ImageWithBasePath
                                            className="border border-white"
                                            source={option?.countryImage}
                                            alt="img"
                                        />
                                    </span>

                                    {option?.countryName}

                                </div>
                                    {/* {option?.countryName} */}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Search Button */}
                {/* <button className="bg-[#E70D0D] text-white px-8 h-[52px] rounded-md w-full md:w-auto">
                    Search
                </button> */}

            </div>
        </div>
    );
};

export default SearchFilterSort;
